module.exports = __webpack_public_path__ + "img/hlsk_logo.b32ce75a.png";